<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-modal ok-only ok-title="关闭" ref="my-modal" title="详情" v-model="stateDetailVisible">
            <p v-for="(item, index) in stateDetailSelect" :key="index">
                <span style="margin-right: 20px">{{ item.time }}</span>
                <b-badge v-if="item.sts == 0" variant="primary">提交审核</b-badge>
                <b-badge v-if="item.sts == 1" variant="danger">审核不通过</b-badge>
                <b-badge v-if="item.sts == 2" variant="secondary">审核通过</b-badge>
                <b-badge v-if="item.sts == 3" variant="primary">再次提交审核</b-badge>
            </p>
        </b-modal>

        <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>

        <b-alert class="mt20" show variant="info">
            <h4 class="alert-heading">首席科学家申请简表申请说明</h4>
            <div v-html="promptMsg1"></div>
        </b-alert>

        <b-row>
            <b-col>
                <b-alert class="mt20" show variant="info">
                    <h4 class="alert-heading">普惠型科学考察项目</h4>
                    <div v-html="promptMsg2"></div>
                    <b-button :disabled="expired" @click="toForm(1)" variant="outline-primary">去申请</b-button>
                </b-alert>
            </b-col>
            <b-col>
                <b-alert class="mt20" show variant="info">
                    <h4 class="alert-heading">重大科学技术问题研究科学考察项目</h4>
                    <div v-html="promptMsg4"></div>
                    <!-- <b-button @click="toForm(2)" variant="outline-primary">去申请</b-button> -->
                    <b-button :disabled="expired" @click="toForm(2)" variant="outline-primary">去申请</b-button>
                </b-alert>
            </b-col>
        </b-row>

        <b-row class="mt20">
            <b-col lg="4" md="4" sm="12" xl="4">
                <h5 class="alert-heading">您的申请记录</h5>
            </b-col>

            <b-col lg="2" md="2" sm="3" xl="2"></b-col>

            <b-col lg="4" md="4" sm="6" xl="4">
                <b-form-select :options="years" @change="requestCsApplyList(true)" placeholder="请选择年份"
                    v-model="reqBody.cruiseYear"></b-form-select>
                <!-- <b-input-group style="float: right">
          <b-form-input placeholder="输入航次名称搜索" v-model="keyword"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="requestCsApplyList(true)">搜索</b-button>
          </b-input-group-append>
        </b-input-group>-->
            </b-col>
        </b-row>

        <b-spinner label="Spinning" v-if="loading" variant="primary"></b-spinner>

        <b-card no-body class="mt20">
            <b-tabs card>
                <b-tab title="普惠型科学考察项目" active>
                    <h3 v-if="!loading && items.length == 0">未查到相关记录</h3>

                    <b-table :fields="fields" :items="items" bordered class="mt10" hover responsive striped
                        style="text-align: left" v-if="items.length > 0">
                        <template v-slot:cell(fileName)="data">
                            <a :href="data.item.fileName2" target="_blank">{{ data.item.fileName }}</a>
                        </template>

                        <template v-slot:cell(operate)="data">
                            <div style="width: 150px">
                                <b-button @click="showStateDetail(data)" class="opButton" size="sm"
                                    variant="outline-primary">状态详情</b-button>
                                <b-button @click="modifyForm(data.item)" class="opButton" size="sm"
                                    variant="outline-primary" :disabled="expired">重新提交</b-button>
                                <b-button @click="downPdf(data.item)" class="opButton" size="sm"
                                    variant="outline-primary">下载PDF</b-button>
                            </div>
                        </template>

                        <template v-slot:cell(status)="data">
                            <b-badge v-if="data.item.status == 0" variant="primary">审核中</b-badge>
                            <b-badge v-if="data.item.status == 1" variant="danger">审核不通过</b-badge>
                            <b-badge v-if="data.item.status == 2" variant="secondary">已审核</b-badge>
                            <b-badge v-if="data.item.status == 3" variant="primary">再次审核中</b-badge>
                        </template>
                    </b-table>

                    <b-pagination :number-of-pages="pagination.totalPage" :per-page="reqBody.pageSize"
                        :total-rows="pagination.total" :value="pagination.page" @change="pageChangeListener"
                        align="center" base-url="#" class="mt20" first-number first-text="首页" last-number last-text="末页"
                        next-text="下一页" prev-text="上一页" v-if="items.length > 0"></b-pagination>
                </b-tab>
                <b-tab title="重大科学技术问题研究科学考察项目">
                    <b-table :fields="fields2" :items="items2" bordered class="mt10" hover responsive striped
                        style="text-align: left; vertical-align: middle" v-if="items2.length > 0">
                        <template v-slot:cell(fileName)="data">
                            <a :href="data.item.fileName2" target="_blank">{{ data.item.fileName }}</a>
                        </template>

                        <template v-slot:cell(operate)="data">
                            <div>
                                <b-button @click="showStateDetail(data)" class="opButton" size="sm"
                                    variant="outline-primary">状态详情</b-button>
                                <b-button @click="modify(data.item)" class="opButton" size="sm"
                                    variant="outline-primary" :disabled="expired">重新提交</b-button>
                                <b-button @click="downPdf(data.item)" class="opButton" size="sm"
                                    variant="outline-primary">下载PDF</b-button>
                            </div>
                        </template>

                        <template v-slot:cell(status)="data">
                            <b-badge v-if="data.item.status == 0" variant="primary">审核中</b-badge>
                            <b-badge v-if="data.item.status == 1" variant="danger">审核不通过</b-badge>
                            <b-badge v-if="data.item.status == 2" variant="secondary">已审核</b-badge>
                            <b-badge v-if="data.item.status == 3" variant="primary">再次审核中</b-badge>
                        </template>
                    </b-table>

                    <b-pagination :number-of-pages="pagination2.totalPage" :per-page="reqBody2.pageSize"
                        @change="pageChangeListener2" :total-rows="pagination2.total" :value="pagination2.page"
                        align="center" base-url="#" class="mt20" first-number first-text="首页" last-number last-text="末页"
                        next-text="下一页" prev-text="上一页" v-if="items2.length > 0"></b-pagination>
                </b-tab>
            </b-tabs>
        </b-card>

        <link-component></link-component>
    </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import Vue from 'vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import { requestCsApply } from '@/api/SvpConfig';

export default {
    components: { LinkComponent },
    name: 'ChiefScientistExplain',
    props: {},
    computed: {
        years: function () {
            // 获取当前年份
            var date = new Date();
            var year = date.getFullYear();
            var years = [];
            // 生成从2015至今年的年份列表
            for (var i = 2015; i <= year + 2; i++) {
                years.push({ value: i, text: i });
            }
            // 倒序排列
            years.reverse();

            // 在起始位置插入全部年份
            years.unshift({ value: null, text: '全部年份' });

            return years;
        }
    },
    data() {
        return {
            reqBody: { page: 1, pageSize: 10, cruiseYear: null, type: 1 },
            reqBody2: { page: 1, pageSize: 10, cruiseYear: null, type: 2 },           
            stateDetailSelect: {},
            stateDetailVisible: false,
            fields: [
                { key: 'applyId', label: '申请编号' },
                { key: 'cruiseNumber', label: '航次编号' },
                { key: 'cruiseName', label: '航次名称' },
                { key: 'fileName', label: '文件' },
                { key: 'status', label: '状态' },
                { key: 'operate', label: '操作' },
            ],

            fields2: [
                { key: 'applyId', label: '申请编号' },
                { key: 'fileName', label: '文件' },
                { key: 'status', label: '状态' },
                { key: 'operate', label: '操作' },
            ],

            bread: [
                {
                    text: '首页',
                    href: '/index',
                },
                {
                    text: '首席科学家申请',
                },
            ],
            promptMsg1: '',
            promptMsg2: '',
            promptMsg3: '',
            promptMsg4: '',
            expired: true,
            items: [],
            items2: [],
            pagination: {},
            pagination2: {},
            loading: true,
            loading2: true,
            keyword: '',
        };
    },
    activated() {
        this.checkLogin();
        requestCsApply().then((resp) => {
            this.promptMsg1 = resp.content1;
            this.promptMsg2 = resp.desc1;
            this.promptMsg3 = resp.content2;
            this.promptMsg4 = resp.desc2;
            this.expired = resp.expired;
        });
        this.requestCsApplyList();
        this.requestCsApplyList2();
    },
    mounted() {
        this.checkLogin();
    },
    methods: {
        modifyForm(item) {            
            this.$router.push({ name: 'ChiefScientistForm', query: { applyId: item.applyId } });
        },
        modify(item) {
            this.$router.push({ name: 'importantPrjCS', query: { applyId: item.applyId } });
        },
        downPdf(item) {
            window.open(item.fileName2, '_blank');
        },
        applyPdf(item) {
            let routeUrl = this.$router.resolve({
                path: '/CsApplyPdf',
                query: { applyId: item.applyId },
            });
            window.open(routeUrl.href, '_blank', 'width=1186px,height=832px,top=0px,left=0px');
        },
        showStateDetail(data) {
            this.stateDetailSelect = JSON.parse(data.item.statusTime);
            this.stateDetailVisible = true;
        },
        goDetail(code, data) {
            this.$router.push({ name: 'ChiefScientistForm', query: { code: code, applyId: data.applyId } });
        },
        requestCsApplyList(isSearchBtnClick) {

            const _this = this

            if (isSearchBtnClick) {
                this.reqBody.page = 1;
                this.reqBody.cruiseName = this.keyword;
            }

            this.loading = true;
            axiosServer({
                url: urls.SvpCsApply,
                params: this.reqBody,
            })
                .then((resp) => {
                    _this.loading = false;
                    resp.data.page.list.forEach((data) => {
                        data.fileName2 = '/imp/' + data.fileName;
                    });
                    _this.items = resp.data.page.list;
                    let page = resp.data.page;
                    _this.pagination = {
                        page: page.page + 1,
                        pageSize: page.pageSize,
                        total: page.total,
                        totalPage: page.totalPage,
                    };
                })
                .catch((e) => {
                    _this.loading = false;
                });
        },

        requestCsApplyList2(isSearchBtnClick) {
            const _this = this

            if (isSearchBtnClick) {
                this.reqBody2.page = 1;
            }

            this.loading2 = true;
            axiosServer({
                url: urls.SvpCsApply,
                params: this.reqBody2,
            })
                .then((resp) => {
                    _this.loading2 = false;
                    _this.items2 = resp.data.page.list;
                    let page = resp.data.page;
                    page.list.forEach((data) => {
                        data.fileName2 = '/imp/' + data.fileName;
                    });
                    _this.pagination2 = {
                        page: page.page + 1,
                        pageSize: page.pageSize,
                        total: page.total,
                        totalPage: page.totalPage,
                    };
                })
                .catch((e) => {
                    _this.loading2 = false;
                });
        },

        checkLogin() {
            let loginName = Vue.ls.get('token');
            if (!loginName) {
                this.$router.push({
                    name: 'login',
                    query: { tip: 1, msg: '访问搭载需求征集页面需要先登录', redirectUrl: 'ChiefScientistExplain' },
                });
            }
        },
        toForm(type) {
            if (type == 2) {
                this.$router.push({ name: 'importantPrjCS', query: { type: type, r: Math.random() } });
            } else {
                this.$router.push({ name: 'ChiefScientistForm', query: { type: type, r: Math.random() } });
            }
        },
        pageChangeListener(page) {
            this.reqBody.page = page;
            this.requestCsApplyList();
        },
        pageChangeListener2(page) {
            this.reqBody2.page = page;
            this.requestCsApplyList2();
        }
    },
};
</script>

<style scoped>
.opButton {
    padding: 2px;
    width: 65px;
    margin-left: 5px;
    margin-top: 5px;
}

.proj-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    padding: 0px;
    margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 576px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 768px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 50px;
    }
}

@media (min-width: 992px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 100px;
    }
}

@media (min-width: 1200px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 200px;
    }
}
</style>
